import { Grid } from '@mui/material';
import React from 'react';
import { TFunction } from 'i18next';
import { TABLE_COLUMNS_IDS } from './tableColumns';
import EditActionButton from '../../../../components/designe/ActionButtons/EditActionButton';
import DeleteActionButton from '../../../../components/designe/ActionButtons/DeleteActionButton';
import { IAiPrompt } from '../../../../types/interfaces/ai-prompt';

export function getCellReducers(
  t: TFunction,
  classes: any,
  { canDelete, canEdit },
  onEdit: (item: IAiPrompt) => void,
  onDelete: (item: IAiPrompt) => void,
) {
  return [
    {
      id: TABLE_COLUMNS_IDS.KEY,
      cellReducer: (item: IAiPrompt) => {
        return <div className={classes.key}>{item.key}</div>;
      },
    },
    {
      id: TABLE_COLUMNS_IDS.VALUE,
      cellReducer: (item: IAiPrompt) => {
        return (
          <div className={classes.value} style={{ maxWidth: 400 }}>
            {item.value}
          </div>
        );
      },
    },
    !canEdit && !canDelete
      ? null
      : {
          id: TABLE_COLUMNS_IDS.ACTIONS,
          cellReducer: (item: IAiPrompt) => {
            return (
              <div className={classes.actions}>
                <Grid
                  className={classes.tdDefault}
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  wrap="nowrap">
                  <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    gap={1}
                    wrap="nowrap">
                    {canEdit && (
                      <EditActionButton onClick={() => onEdit(item)} />
                    )}
                    {canDelete && (
                      <DeleteActionButton onClick={() => onDelete(item)} />
                    )}
                  </Grid>
                </Grid>
              </div>
            );
          },
        },
  ].filter(Boolean);
}
